module.exports = __webpack_public_path__ + "img/12ne.72be9b5e.svg";